import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-a1eon4-0"
})(["table{td{width:25%;width:300px;border-right:1px solid ", ";background-color:transparent;&:first-child{font-weight:700;text-align:left;}}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.terciaryM;
});
export var ModalInner = styled.div.withConfig({
  displayName: "Inner__ModalInner",
  componentId: "sc-a1eon4-1"
})(["margin-top:0;"]);